import dayjs from 'dayjs';
import { useAtom } from 'jotai';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Components
import Timepicker from '@/components/base/Timepicker';
// Atoms
import { deadlineDateTimeAtom } from '@/components/pages/giveaway-picker/Atoms/OptionsAtoms';

export const TimeSection = () => {
    const { t } = useTranslation('giveaway_picker');
    const [deadlineDateTime, setDeadlineDateTime] = useAtom(deadlineDateTimeAtom);
    const time = dayjs(deadlineDateTime).format('HH:mm');

    const handleChange = (time: Date) => {
        const formattedTime = dayjs(time).format('HH:mm:00');
        const currentDate = dayjs(deadlineDateTime).format('YYYY-MM-DD');

        setDeadlineDateTime(`${currentDate}T${formattedTime}`);
    };
    return (
        <span className="w-2/4">
            <span className="mb-1.5 inline-block font-GMedium text-xs text-icoGray-400">
                {t('options.deadline_group.select_time')}
            </span>

            <Timepicker time={time} onChange={handleChange} hasBorder={true} />
        </span>
    );
};
